(function () {
    'use strict';

    angular
        .module('app.application')
        .controller('ApplicationEditController', ApplicationEditController);

    /* @ngInject */
    function ApplicationEditController(logger,
        applicationService,
        $uibModalInstance,
        application,
        moment,
        $filter) {

        var vm = this;
        vm.title = 'Edit application';
        vm.application = application;
        vm.applicationFields = applicationService.getApplicationFields();

        vm.save = save;
        vm.reset = reset;

        activate();

        function activate() {
            vm.application.DateCreated = moment(application.DateCreated).toDate();
            vm.application.DateUpdated = moment(application.DateUpdated).toDate();

            setForm();

            logger.info('Activated application Edit View');
        }

        function save() {
            if (vm.applicationForm.$valid) {
                applicationService.saveApplication(vm.application)
                    .then(function (result) {
                        if (result.status === 200) {
                            var application = $filter('filter')(
                               vm.applicationFields[3].fieldGroup[1].templateOptions.options, {
                                    ApplicationTypeId: result.data.ApplicationTypeId
                                }, true);

                            vm.application.ApplicationType = application[0];

                            $uibModalInstance.close(vm.application);
                        } else {
                            logger.info('issue saving application');
                        }
                    });
            }
        }

        function reset() {
            $uibModalInstance.dismiss('cancel');
        }

        function setForm() {
            vm.applicationFields[6].fieldGroup[0].className = 'col-xs-6';
            vm.applicationFields[6].fieldGroup.push({
                className: 'col-xs-6',
                key: 'DateUpdated',
                type: 'datepicker',
                ngModelAttrs: {
                    customAttrVal: {
                        attribute: 'disabled'
                    }
                },
                templateOptions: {
                    label: 'Date Updated',
                    type: 'text',
                    datepickerPopup: 'dd-MMMM-yyyy',
                    disabled: true
                }
            });
        }
    }
})();
